import React from "react";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { connect } from "react-redux";
import { setRadioAnswerChoice } from "../state/domains";
import Box from "@mui/material/Box";

const RadioChoices = props => {
  const { card, _setAnswerChoice } = props;
  const { question, qnId, choices } = card;
  let i = 0;
  /*     const [options, setState] = useState(choices)
    const isMounted = useRef(false);
    useEffect(() => {
        if (isMounted.current) {
        setState(state => state.questions.quizQuestionData.filter(card => card.page === page && card.type === "radio"));
        }
        else isMounted.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_setAnswerChoice]); */
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        md={5}
        sx={{ "padding-top": "2vh", "padding-bottom": "2vh" }}>
        <Box
          sx={{
            display: "flex",
            fontWeight: "bold",
            boxShadow: 1,
            borderRadius: 2,
            "background-color": "#e7ede0",
            p: 1,
          }}>
          {" "}
          {question}:{" "}
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ "padding-bottom": "2vh", "padding-left": "3vh" }}>
        <FormControl>
          <RadioGroup aria-labelledby={qnId} row>
            {choices.map(({ choice, option, selected }) => {
              ++i;
              return (
                <FormControlLabel
                  value={option}
                  control={
                    <Radio
                      key={`${qnId}-radio-${i}`}
                      checked={selected}
                      name={`${qnId}-radio-${i}`}
                      onChange={() => {
                        _setAnswerChoice(qnId, option);
                      }}
                    />
                  }
                  label={choice}
                />
              );
            })}
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};
function mapDispatchToProps(dispatch) {
  return {
    _setAnswerChoice: (questionIndex, choiceIndex, value) =>
      dispatch(setRadioAnswerChoice(questionIndex, choiceIndex, value)),
  };
}

export default connect(null, mapDispatchToProps)(RadioChoices);
